import { render, staticRenderFns } from "./BoxOnboarding.vue?vue&type=template&id=cfa17aee&"
import script from "./BoxOnboarding.vue?vue&type=script&lang=js&"
export * from "./BoxOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./BoxOnboarding.vue?vue&type=style&index=0&id=cfa17aee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,Scroll} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Scroll})
